import { call, takeEvery } from 'redux-saga/effects';
import { request } from 'components/Fetch';
import urls from 'config/urls';
import { EsignModificationConstants } from 'constants/eSignContractModification';

function* fetchContractSaga(action) {
  yield call(request({
    type: EsignModificationConstants.FETCH_CONTRACT_MODIFICATION,
    method: 'GET',
    url: urls.fetchContractModificationAgreement(action.payload.entityType, action.payload.loanId, action.payload.contractId, action.payload.key),
  }), action);
}

function* fetchSettlementSaga(action) {
  yield call(request({
    type: EsignModificationConstants.FETCH_SETTLEMENT_MODIFICATION,
    method: 'GET',
    url: urls.fetchSettlementModificationAgreement(action.payload.entityType, action.payload.loanId, action.payload.settlementId, action.payload.key),
  }), action);
}

function* esignModificationDocumentSaga(action) {
  yield call(request({
    type: EsignModificationConstants.ESIGN_CONTRACT_MODIFICATION,
    method: 'POST',
    url: urls.esignContractModificationAgreement(action.payload.entityType, action.payload.entityId, action.payload.contractId),
  }), action);
}

function* esignSettlementDocumentSaga(action) {
  yield call(request({
    type: EsignModificationConstants.ESIGN_SETTLEMENT_MODIFICATION,
    method: 'POST',
    url: urls.esignSettlementAgreement(action.payload.entityType, action.payload.entityId, action.payload.settlementId),
  }), action);
}

function* fetchScraWaiverSaga(action) {
  yield call(request({
    type: EsignModificationConstants.FETCH_SCRA_WAIVER,
    method: 'GET',
    url: urls.fetchScraWaiverDocument(action.payload.entityType, action.payload.entityId, action.payload.scraId, action.payload.key),
  }), action);
}

function* esignScraWaiverSaga(action) {
  yield call(request({
    type: EsignModificationConstants.ESIGN_SCRA_WAIVER,
    method: 'POST',
    url: urls.esignScraWaiver(action.payload.entityType, action.payload.entityId, action.payload.scraId),
  }), action);
}

const eSignContractModificationSaga = function* () {
  yield takeEvery(EsignModificationConstants.FETCH_CONTRACT_MODIFICATION, fetchContractSaga);
  yield takeEvery(EsignModificationConstants.FETCH_SETTLEMENT_MODIFICATION, fetchSettlementSaga);
  yield takeEvery(EsignModificationConstants.FETCH_SCRA_WAIVER, fetchScraWaiverSaga);
  yield takeEvery(EsignModificationConstants.ESIGN_CONTRACT_MODIFICATION, esignModificationDocumentSaga);
  yield takeEvery(EsignModificationConstants.ESIGN_SETTLEMENT_MODIFICATION, esignSettlementDocumentSaga);
  yield takeEvery(EsignModificationConstants.ESIGN_SCRA_WAIVER, esignScraWaiverSaga);
};

export default eSignContractModificationSaga;
